import { Record } from "immutable";
import {
    BlockDestination,
    ExistingPageDestination,
    NewNotebookDestination,
    NewPageDestination,
} from "models/interfaces/populated-blocks/block-destination";

// region Existing Page Destination

const existingPageDefaults: ExistingPageDestination = {
    kind: "existingPage",
    pageId: 0,
};

export class ExistingPageDestinationRecord
    extends Record(existingPageDefaults)
    implements ExistingPageDestination
{
    constructor(params?: Partial<ExistingPageDestination>) {
        if (params == null) {
            params = Object.assign({}, existingPageDefaults);
        }

        super(params);
    }

    public with(
        values: Partial<ExistingPageDestination>
    ): ExistingPageDestinationRecord {
        return new ExistingPageDestinationRecord(
            Object.assign(this.toJS(), values)
        );
    }
}

// endregion

export type BlockDestinationRecord =
    | ExistingPageDestinationRecord
    | NewPageDestinationRecord
    | NewNotebookDestinationRecord;

export const BlockDestinationRecordFactory = (
    destination: BlockDestination
): BlockDestinationRecord => {
    switch (destination.kind) {
        case "existingPage":
            return new ExistingPageDestinationRecord(destination);
        case "newPage":
            return new NewPageDestinationRecord(destination);
        case "newNotebook":
            return new NewNotebookDestinationRecord(destination);
    }
};

// region New Page Destination

const newPageDefaults: NewPageDestination = {
    kind: "newPage",
    notebookId: 0,
    pageName: undefined,
};

export class NewPageDestinationRecord
    extends Record(newPageDefaults)
    implements NewPageDestination
{
    constructor(params?: Partial<NewPageDestination>) {
        if (params == null) {
            params = Object.assign({}, newPageDefaults);
        }

        super(params);
    }

    public with(values: Partial<NewPageDestination>): NewPageDestinationRecord {
        return new NewPageDestinationRecord(Object.assign(this.toJS(), values));
    }
}

// endregion

// region New Notebook Destination

const newNotebookDefaults: NewNotebookDestination = {
    kind: "newNotebook",
    notebookName: "",
};

export class NewNotebookDestinationRecord
    extends Record(newNotebookDefaults)
    implements NewNotebookDestination
{
    constructor(params?: Partial<NewNotebookDestination>) {
        if (params == null) {
            params = Object.assign({}, newNotebookDefaults);
        }

        super(params);
    }

    public with(
        values: Partial<NewNotebookDestination>
    ): NewNotebookDestinationRecord {
        return new NewNotebookDestinationRecord(
            Object.assign(this.toJS(), values)
        );
    }
}

// endregion
